const ErrorFull = () => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_diii_29159_25441)">
        <g clipPath="url(#clip0_29159_25441)">
          <path
            d="M8 36C8 18.3269 22.3269 4 40 4C57.6731 4 72 18.3269 72 36C72 53.6731 57.6731 68 40 68C22.3269 68 8 53.6731 8 36Z"
            fill="#D71313"
          />
          <rect x="8" y="4" width="64" height="64" rx="32" fill="url(#paint0_linear_29159_25441)" />
          <g opacity="0.4">
            <path
              d="M32.7026 12.6766C32.3362 11.3118 30.9266 10.4894 29.605 10.9902C23.6104 13.2587 18.6849 17.6932 15.8018 23.4174C15.165 24.6814 15.8354 26.1694 17.1554 26.675C18.4754 27.1822 19.9426 26.5134 20.6114 25.267C22.8646 21.0577 26.5178 17.7678 30.9394 15.9662C32.2498 15.4318 33.0674 14.043 32.7026 12.6782V12.6766Z"
              fill="#F2F6FF"
            />
          </g>
          <g filter="url(#filter1_ddd_29159_25441)">
            <g filter="url(#filter2_d_29159_25441)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.0376 26.2374C38.3606 23.9694 41.6377 23.9694 42.9607 26.2374L50.9812 39.9868C52.3145 42.2725 50.6658 45.1429 48.0196 45.1429H31.9787C29.3325 45.1429 27.6838 42.2725 29.0171 39.9868L37.0376 26.2374ZM40.0003 31.4287C40.6315 31.4287 41.1431 31.9404 41.1431 32.5715V36.0001C41.1431 36.6313 40.6315 37.143 40.0003 37.143C39.3691 37.143 38.8574 36.6313 38.8574 36.0001V32.5715C38.8574 31.9404 39.3691 31.4287 40.0003 31.4287ZM38.5717 39.4287C38.5717 38.6397 39.2113 38.0001 40.0003 38.0001C40.7893 38.0001 41.4289 38.6397 41.4289 39.4287C41.4289 40.2177 40.7893 40.8573 40.0003 40.8573C39.2113 40.8573 38.5717 40.2177 38.5717 39.4287Z"
                fill="white"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_diii_29159_25441"
          x="-9.53674e-07"
          y="-4"
          width="80"
          height="84"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29159_25441" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29159_25441"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_29159_25441" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_29159_25441"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.729412 0 0 0 0 0.109804 0 0 0 0 0.105882 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_29159_25441"
            result="effect3_innerShadow_29159_25441"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-8" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.862745 0 0 0 0 0.862745 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_29159_25441"
            result="effect4_innerShadow_29159_25441"
          />
        </filter>
        <filter
          id="filter1_ddd_29159_25441"
          x="12.5709"
          y="20.5715"
          width="54.8563"
          height="70.2857"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="13.7143"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_29159_25441"
          />
          <feOffset dy="27.4286" />
          <feGaussianBlur stdDeviation="13.7143" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29159_25441" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3.42857"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_29159_25441"
          />
          <feOffset dy="6.85714" />
          <feGaussianBlur stdDeviation="3.42857" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_29159_25441"
            result="effect2_dropShadow_29159_25441"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.71429"
            operator="dilate"
            in="SourceAlpha"
            result="effect3_dropShadow_29159_25441"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_29159_25441"
            result="effect3_dropShadow_29159_25441"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_29159_25441"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_29159_25441"
          x="-26.3122"
          y="-21.1779"
          width="132.623"
          height="130.321"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9.14286" />
          <feGaussianBlur stdDeviation="27.4286" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.439216 0 0 0 0 0.482353 0 0 0 0 0.627451 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_29159_25441" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29159_25441"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_29159_25441"
          x1="40"
          y1="4"
          x2="40"
          y2="68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.16" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_29159_25441">
          <path
            d="M8 36C8 18.3269 22.3269 4 40 4C57.6731 4 72 18.3269 72 36C72 53.6731 57.6731 68 40 68C22.3269 68 8 53.6731 8 36Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ErrorFull
